/**
 * ICAO → lat/lon for Destinations map + mint distance.
 *
 * Settings Community / Content.xml detect yields 4-letter tokens with no
 * coordinates. The hard-coded AIRPORTS catalog is only ~70 fields, so Show
 * destinations used to plot a handful. This table is a public OurAirports
 * ident extract (large/medium/small/seaplane + closed ICAO keywords).
 *
 * Airports still missing here cannot be plotted or ranged — that leftover
 * filter is documented, not a second catalog.
 */
import icaoCoords from "./data/icaoCoords.json";

export type AirportCoords = { lat: number; lon: number };

/** JSON imports as number[], not a 2-tuple — validate length at lookup. */
const TABLE = icaoCoords as Record<string, number[]>;

export function lookupAirportCoords(icao?: string | null): AirportCoords | null {
  const code = (icao ?? "").trim().toUpperCase();
  if (!code) return null;
  const hit = TABLE[code];
  if (!hit) return null;
  const lat = hit[0];
  const lon = hit[1];
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  return { lat, lon };
}

export function icaoCoordsCount(): number {
  return Object.keys(TABLE).length;
}
